module.exports = __webpack_public_path__ + "img/connect-blue.82deffca.svg";